import { Instagram, Facebook } from "lucide-react";
import BrandLogo from "@/components/landing/BrandLogo";
import { businessConfig } from "@/config";

export default function LandingFooter() {
  const year = new Date().getFullYear();
  return (
    <footer className="landing-footer" data-testid="landing-footer">
      <div className="landing-footer__inner">
        <div className="landing-footer__col">
          <div className="landing-footer__brand">
            <BrandLogo size={36} iconSize={18} className="landing-footer__logo" />
            <span className="landing-footer__brand-name">{businessConfig.name}</span>
          </div>
          <p className="landing-footer__brand-blurb">
            Master-certified grooming, daycare and boarding. Proud Running Wild
            Rescue partner since 2018.
          </p>
        </div>

        <div className="landing-footer__col">
          <span className="overline">VISIT</span>
          <p className="landing-footer__lines">
            290 9th Ave NW
            <br />
            Moose Jaw, SK
            <br />
            <a href="tel:3066910001">306-691-0001</a>
          </p>
        </div>

        <div className="landing-footer__col">
          <span className="overline">FOLLOW</span>
          <div className="landing-footer__social">
            <a
              href="https://instagram.com/pupsparlour.grooming"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-instagram"
            >
              <Instagram className="w-4 h-4" />
              Instagram
            </a>
            <a
              href="https://facebook.com/pawsnplaygroomcatlodgerescue"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-facebook"
            >
              <Facebook className="w-4 h-4" />
              Facebook
            </a>
          </div>
        </div>
      </div>

      <div className="landing-footer__bottom">
        <span>© {year} Pup's Parlour Inc.</span>
        <span>
          {"Designed and built by "}
          <a
            href="https://failedpainter.com"
            target="_blank"
            rel="noopener noreferrer"
            className="landing-footer__credit-link"
            data-testid="footer-credit-link"
          >
            Failed Painter
          </a>
        </span>
      </div>
    </footer>
  );
}
